// CategoryListBlock — відображає список категорій і генерує запити в чат.
import '../../styles/CategoryListBlock.css'

export default function CategoryListBlock({ block, onAction }) {
  return (
    <div className="block">
      <div className="blockTitle">{block.title || "Категорії"}</div>

      <div className="categoryList">
        {block.categories?.map((c) => (
          <span
            key={c.id}
            className="categoryLink"
            onClick={() =>
              onAction({ type: "send", message: c.title })
            }
          >
            {c.title}
          </span>
        ))}
      </div>
    </div>
  );
}
